import ApiBase from '../ApiBase';

class Agenda extends ApiBase {
    route = '/agenda/agenda';
};

export default new Agenda();